import { Settings } from "@mui/icons-material";
import { Box, Divider, List, ListItem, ListSubheader, Stack, Typography } from "@mui/joy";
import { Outlet } from "@tanstack/react-router";

import { useCurrentVenueQuery } from "@/hooks/venues";

import { ListItemButtonLink } from "../Links";

const VenueSettingsNav = () => {
  const { data: venue } = useCurrentVenueQuery();
  const baseUrl = "/gym/$venueUuid/settings";
  return (
    <List
      sx={{
        width: 250,
        flexGrow: 0,
        backgroundColor: "neutral.100",
        borderLeft: "1px solid",
        borderRight: "1px solid",
        borderColor: "neutral.200",
        borderTopLeftRadius: 16,
        borderBottomLeftRadius: 16,
        overflow: "hidden",
        ".Mui-selected": {
          color: "var(--joy-palette-primary-blue2)",
          backgroundColor: "transparent!important",
          fontWeight: "bold!important",
        },
        "a:hover": {
          backgroundColor: "var(--joy-palette-primary-100)!important",
        },
        ".MuiListSubheader-root": {
          fontWeight: "bold",
          textTransform: "none",
          letterSpacing: "0",
          color: "neutral.600",
          fontSize: "14px",
        },
        ".MuiListItemButton-root": {
          fontWeight: "bold",
          fontSize: "16px",
        },
      }}
    >
      <ListItem>
        <Typography level="title-md" startDecorator={<Settings fontSize="small" />}>
          Gym Settings
        </Typography>
      </ListItem>
      <Divider />
      <ListItemButtonLink to="./colors" from={baseUrl} activeProps={{ selected: true }}>
        Colors
      </ListItemButtonLink>
      {venue?.userRole === "ADMIN" ? (
        <ListItemButtonLink to="./labels" from={baseUrl} activeProps={{ selected: true }}>
          Labels
        </ListItemButtonLink>
      ) : null}
      {/* <ListItemButtonLink
        to="./profile"
        from={baseUrl}
        activeProps={{ selected: true }}
      >
        Profile
      </ListItemButtonLink> */}
      <Divider />
      {venue?.climbTypes.includes("BOULDER") ? (
        <>
          {venue.climbTypes.length > 1 ? <ListSubheader>Bouldering</ListSubheader> : null}
          {/* <ListItemButtonLink
            activeProps={{ selected: true }}
            to="./circuits"
            from={baseUrl}
          >
            Circuits
          </ListItemButtonLink> */}
          <ListItemButtonLink activeProps={{ selected: true }} to="./zones" from={baseUrl}>
            Zones
          </ListItemButtonLink>
          <ListItemButtonLink
            activeProps={{ selected: true }}
            to="./targets/$climbType"
            params={{ climbType: "boulder" }}
            from={baseUrl}
          >
            Targets
          </ListItemButtonLink>
          <Divider />
        </>
      ) : null}
      {venue?.climbTypes.includes("SPORT") ? (
        <>
          {venue.climbTypes.length > 1 ? <ListSubheader>Sport</ListSubheader> : null}
          <ListItemButtonLink activeProps={{ selected: true }} to="./lines" from={baseUrl}>
            Lines
          </ListItemButtonLink>
          <ListItemButtonLink activeProps={{ selected: true }} to="./sectors" from={baseUrl}>
            Sectors
          </ListItemButtonLink>
          <ListItemButtonLink
            activeProps={{ selected: true }}
            to="./targets/$climbType"
            params={{
              climbType: "sport",
            }}
            from={baseUrl}
          >
            Targets
          </ListItemButtonLink>
          <Divider />
        </>
      ) : null}
      {venue?.userRole === "ADMIN" ? (
        <ListItemButtonLink activeProps={{ selected: true }} to="./credits" from={baseUrl}>
          Credits
        </ListItemButtonLink>
      ) : null}
      {/* <ListItemButtonLink
        activeProps={{ selected: true }}
        to="./billing"
        from={baseUrl}
      >
        Billing
      </ListItemButtonLink> */}
    </List>
  );
};

export default function VenueSettings() {
  return (
    <Stack direction="row" sx={{ height: "100dvh" }}>
      <VenueSettingsNav />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Outlet />
      </Box>
    </Stack>
  );
}
